import { CarouselStore } from 'component/Carousel/store/CarouselStore'
import { makeAutoObservable } from 'mobx'
import { createContext, ReactNode, useContext, useMemo } from 'react'
import { opt } from 'store/opt'
import { store } from 'store/store'

const f1 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/fullbody-f1-952d.jpg'
const f2 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/fullbody-f2-12c9.jpg'
const f3 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/fullbody-f3-2f2d.jpg'
const f4 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/fullbody-f4-8f0d.jpg'
const f5 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/fullbody-f5-acf2.jpg'
const m1 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/fullbody-m1-13ad.jpg'
const m2 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/fullbody-m2-f99b.jpg'
const m3 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/fullbody-m3-c27e.jpg'
const m4 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/fullbody-m4-d952.jpg'
const m5 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/fullbody-m5-5f15.jpg'

export type AssetItem = {
  name: string
  src: string
}

export type Item = AssetItem | undefined

const FEMALE: AssetItem[] = [
  { name: 'f1', src: f1 },
  { name: 'f2', src: f2 },
  { name: 'f3', src: f3 },
  { name: 'f4', src: f4 },
  { name: 'f5', src: f5 },
]

const MALE: AssetItem[] = [
  { name: 'm1', src: m1 },
  { name: 'm2', src: m2 },
  { name: 'm3', src: m3 },
  { name: 'm4', src: m4 },
  { name: 'm5', src: m5 },
]

const DEF: AssetItem[] = [...FEMALE, ...MALE]

function getAssets(): AssetItem[] {
  const selfies = opt.options.bodies
  if (!selfies?.on) return []

  const male = selfies.male ?? []
  const female = selfies.female ?? []
  const custom = [...male, ...female]
  if (custom.length) return custom.map(it => ({ name: 'custom', src: it }))

  const avatarGender = opt.options.avatar_gender
  if (avatarGender === 'female') return FEMALE
  if (avatarGender === 'male') return MALE

  return DEF
}

function createCarousel() {
  const assets = getAssets()
  return new CarouselStore([undefined, ...assets], { gap: 12 })
}

function isAssetSelected(it: AssetItem): boolean {
  const src = store.profile?.common.userPhoto.src
  return !!src && src.startsWith(it.src)
}

export class FullbodyStore {
  readonly carousel = createCarousel()

  constructor() {
    makeAutoObservable(this)
    this.carousel.item = this.selected
  }

  get custom(): boolean {
    return !this.selected
  }

  get selected(): Item {
    return this.carousel.items.find(it => it && isAssetSelected(it))
  }
}

const Context = createContext<FullbodyStore | undefined>(undefined)
const Provider = Context.Provider

type Props = {
  children: ReactNode
}

export function FullbodyProvider({ children }: Props) {
  const fullbody = useMemo(() => new FullbodyStore(), [])

  return <Provider value={fullbody}>
    {children}
  </Provider>
}

export function useFullbody(): FullbodyStore {
  const fullbody = useContext(Context)
  if (!fullbody) throw new Error('no fullbody')
  return fullbody
}
